import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { notification, Spin } from "antd";
import "../../assets/css/videorecorder.css";
import { useLocation, useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../../constants/approutes";

const NWAPI_URL = process.env.REACT_APP_SMARTVITAL;
const API_URL = process.env.REACT_APP_API_URL;

const VideoCaptureComponent = () => {
  const videoRef = useRef(null);
  const [patientDetails, setPatientDetails] = useState(null);
  const [isCameraOn, setIsCameraOn] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [countdown, setCountdown] = useState(3);
  const [isCountdownActive, setIsCountdownActive] = useState(false);
  const [recordingTimeLeft, setRecordingTimeLeft] = useState(30);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isPreparingDataLoading, setIsPreparingDataLoading] = useState(false);

  const formData = JSON.parse(localStorage.getItem("smartVitalFormData"));
  const location = useLocation();
  const { patientCode } = location.state || {};
    const navigate = useNavigate();

  console.log(patientCode, "gtfyhvhhcgh")


  useEffect(() => {
    const fetchPatient = async () => {

      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");
      if (patientCode && token) {
        try {
          const response = await axios.get(`${API_URL}patient/search?patientId=${patientCode}`, {
            headers: { Authorization: `Bearer ${token}`, tenantId: tenantId },
          });
          const firstPatient = response?.data.data[0];
          console.log(response.data, "wsredtgyuhj")
          setPatientDetails(firstPatient);
        } catch (error) {
          console.error("Error fetching patient details:", error);
        }
      }
    };

    fetchPatient();
    initializeCamera();
    return () => stopCamera();
  }, []);

  const initializeCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        await videoRef.current.play();
        setIsCameraOn(true);
      }
    } catch (error) {
      console.error("Error accessing camera:", error);
    }
  };

  const stopCamera = () => {
    if (videoRef.current?.srcObject) {
      videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      videoRef.current.srcObject = null;
      setIsCameraOn(false);
    }
  };

  const startRecording = async () => {
    if (!isCameraOn) await initializeCamera();

    if (!videoRef.current || !videoRef.current.srcObject) {
      console.warn("Camera not ready");
      return;
    }

    setIsCountdownActive(true);
    let timerValue = 3;
    setCountdown(timerValue);

    const countdownInterval = setInterval(() => {
      timerValue -= 1;
      setCountdown(timerValue);
      if (timerValue <= 0) {
        clearInterval(countdownInterval);
        setIsCountdownActive(false);
        setCountdown(3);
        beginRecording();
      }
    }, 1000);
  };

  const beginRecording = () => {
    const isMp4Supported = MediaRecorder.isTypeSupported("video/mp4;codecs=avc1");
    const mimeType = isMp4Supported ? "video/mp4" : "video/webm";
    const stream = videoRef.current.srcObject;
    const recorder = new MediaRecorder(stream, { mimeType });
    const chunks = [];
    let stoppedByTimer = false;

    recorder.ondataavailable = (event) => {
      if (event.data.size > 0) chunks.push(event.data);
    };

    recorder.start();
    setMediaRecorder(recorder);
    setIsRecording(true);

    let timeLeft = 30;
    setRecordingTimeLeft(timeLeft);
    const totalStrokeDasharray = 1256.64;

    const recordingTimer = setInterval(() => {
      timeLeft -= 1;
      setRecordingTimeLeft(timeLeft);

      const progress = (timeLeft / 30) * totalStrokeDasharray;
      const progressCircle = document.querySelector(".video-recorder-circle-progress");
      if (progressCircle) {
        progressCircle.style.strokeDashoffset = progress.toString();
      }

      if (timeLeft <= 0) {
        clearInterval(recordingTimer);
        if (recorder.state !== "inactive") {
          recorder.stop();
          stoppedByTimer = true;
        }
        setIsRecording(false);
      }
    }, 1000);

    recorder.onstop = () => {
      const blob = new Blob(chunks, { type: mimeType });
      if (stoppedByTimer) {
        uploadVideo(blob);
        stopCamera();
      }
    };
  };

  const stopRecording = () => {
    if (mediaRecorder && mediaRecorder.state !== "inactive") {
      mediaRecorder.stop();
      setIsRecording(false);
    }
  };

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    if (
      today.getMonth() < birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  const uploadVideo = async (blob) => {
    if (!blob || !patientDetails || isSubmitted || isPreparingDataLoading) return;

    setIsPreparingDataLoading(true);
    const storedAnswers = JSON.parse(sessionStorage.getItem("calculatedAnswers")) || [];

    const formDataPayload = new FormData();
    formDataPayload.append("patient_code", patientDetails?.patientCode);
    formDataPayload.append("name", `${patientDetails?.firstName || ""} ${patientDetails?.lastName || ""}`);
    formDataPayload.append("age", calculateAge(patientDetails?.dob));
    formDataPayload.append("gender", patientDetails?.gender);
    formDataPayload.append("height", parseInt(formData?.heightCm, 10));
    formDataPayload.append("height_unit", formData?.heightUnit);
    formDataPayload.append("weight", parseInt(formData?.weight, 10));
    formDataPayload.append("weight_unit", formData?.weightUnit);
    formDataPayload.append("smoke", formData?.smoke);
    formDataPayload.append("diabetes", formData?.diabetes);

    storedAnswers.forEach((ans, index) => {
      formDataPayload.append(`q${index + 1}_${getQuestionKey(index + 1)}`, ans);
    });

    formDataPayload.append("video", blob, "recorded-video.mp4");
    console.log(formDataPayload, "wasedfghjk", patientDetails)
    try {
      const response = await axios.post(`${NWAPI_URL}process-video/`, formDataPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200) {
        stopCamera();
        setIsPreparingDataLoading(false);
        sessionStorage.setItem("predictedVitals", JSON.stringify(response.data.data));
        navigate(APP_ROUTES.PATIENTREGISTER, {
          state: {
            patientCode: patientDetails?.patientCode,
          },
        });
      }

    } catch (error) {
      console.error("Upload failed:", error);
      stopCamera();
      setIsPreparingDataLoading(false);
      setIsSubmitted(false);
      notification.error({
        message: "Submission Failed",
        description: "Please try again.",
        duration: 5,
        placement: "top",
      });
    }
  };

  const getQuestionKey = (index) => {
    return [
      "perceived_stress",
      "fatigue_level",
      "sleep_quality_index",
      "cognitive_impairment_index",
      "overwork_index",
      "mental_effort_index",
      "nervousness",
      "stress_level",
    ][index - 1];
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      {isPreparingDataLoading ? (
        <div className="flex flex-col items-center justify-center min-h-screen">
          <Spin />
          <p className="text-lg font-semibold mt-4 text-primaryColor">
            Please wait, preparing your vitals report...
          </p>
        </div>
      ) : (
        <div className="flex flex-col items-center max-w-md w-full mx-auto py-10">
          <h1 className="text-2xl font-semibold text-center mb-6 text-[#004276]">
            Smart Vital <span className="text-[#3cba84]">Camera Capture</span>
          </h1>

          <div
            className={`relative w-[300px] h-[300px] rounded-full overflow-hidden shadow-lg 
    ${isRecording ? "recording-glow" : "border-4 border-[#3cba84]"}`}
          >
            <video
              ref={videoRef}
              autoPlay
              muted
              className="w-full h-full object-cover flip-horizontal"
            />
          </div>


          {/* Countdown Number */}
          {isCountdownActive && (
            <div className="text-6xl font-bold text-[#3cba84] mt-6 animate-pulse">
              {countdown}
            </div>
          )}

          {/* Buttons */}
          <div className="mt-8 flex flex-col items-center">
            {!isCountdownActive && !isRecording && (
              <button
                onClick={startRecording}
                className="bg-[#004276] hover:bg-[#3cba84] text-white text-lg px-8 py-3 rounded-full shadow-md transition-all"
              >
                Start Recording
              </button>
            )}

            {isRecording && (
              <>
                <p className="text-md font-medium text-[#004276] mt-4">
                  Recording... Time left: {recordingTimeLeft}s
                </p>
                <button
                  onClick={stopRecording}
                  className="bg-red-500 hover:bg-red-600 text-white text-lg px-6 py-2 mt-4 rounded-full shadow-md"
                >
                  Stop Recording
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );

};

export default VideoCaptureComponent;
